document.addEventListener('alpine:init', () => {
    Alpine.data('navigation', function () {
        return {
            menuIsOpen: false,
            menuPanel: 'menu',
            scrolled: false,
            subNavOpen: false,
            init() {
                window.addEventListener('scroll', () => {
                    this.scrolled = window.scrollY > 0;
                });
                // add event listener for sub-menu-open and sub-menu-close
                document.addEventListener('sub-menu-open', () => {
                    this.subNavOpen = true;
                });
                document.addEventListener('sub-menu-close', () => {
                    this.subNavOpen = false;
                });
            },
            toggleMenu() {
                this.menuIsOpen = !this.menuIsOpen;
            },
            toggleSubNav() {
                this.subNavOpen = !this.subNavOpen;
            }
        }
    });
});

document.addEventListener('alpine:init', () => {
    let openSubMenuCount = 0;

    Alpine.data('menuItem', () => ({
        subMenuIsOpen: false,
        init() {
            this.$watch('subMenuIsOpen', (isNavOpen) => {
                if (isNavOpen) {
                    openSubMenuCount++;
                    this.$nextTick(() => {
                        document.dispatchEvent(new CustomEvent('sub-menu-open'));
                    });
                } else {
                    openSubMenuCount--;
                    if (openSubMenuCount <= 0) {
                        document.dispatchEvent(new CustomEvent('sub-menu-close'));
                    }
                }
            });
        },
    }));
});
